import { clsx, type ClassValue } from 'clsx';

/**
 * Utility function to merge class names using clsx
 * This is a common pattern in modern React applications
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}